// extracted by mini-css-extract-plugin
export default {"chip":"status-chip_chip__QT9aC"};